module.exports = __webpack_public_path__ + "static/media/this-global.9b00aaa2.png";